import { canonicalJson } from './patchHash.js';
// Existing web port of api/workflow/patch-hash.ts; shared vector checks both.
export { canonicalJson };
export async function patchSha256(patch: unknown): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(canonicalJson(patch)));
  return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
}
